module.exports = {"extralarge":"4em","large":"1.7em","medium":"1.3em","small":"1em","extrasmall":"0.85em"}


//////////////////
// WEBPACK FOOTER
// ./src/data/fontsizes.yaml
// module id = 106
// module chunks = 35783957827783 114276838955818